import * as React from "react";

import { Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { WithTranslation, withTranslation } from "react-i18next";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";

export const RMAError: React.StatelessComponent<WithTranslation> = ({ t }) => (
  <Callout
    intent={Intent.DANGER}
    icon={IconNames.ERROR}
    title={t("errors.cannotCancelOrder.title")}
    children={t("errors.cannotCancelOrder.description")}
  />
);

export const RMACancelErrorI18n = withTranslation("rmaForm")(RMAError);



// WEBPACK FOOTER //
// ./src/components/RMAForm/RMACancelError.tsx